import './App.scss';
import * as React from 'react';
import Main from "./components/Main";

export default class ErrorApp extends React.Component {

    public render() {
      return (
        <Main className="errorApp" title="Error">
          <div className="text-center">
            Oops ! une erreur est survenue dans l'intégration RTFM.
          </div>
        </Main>
      );
    }

}

